document.addEventListener('click', function (event) {
  const button = event.target.closest('.fg-price-range');

  if (!button) return;

  const filter = button.closest('.fg-price-filter');

  if (!filter) return;

  const minInput = filter.querySelector('.fg-price-min-input');
  const maxInput = filter.querySelector('.fg-price-max-input');

  if (!minInput || !maxInput) return;

  const min = button.dataset.priceMin;
  const max = button.dataset.priceMax;

  minInput.value = min;
  maxInput.value = max;

  const form = button.closest('form');

  if (!form) return;

  form.requestSubmit();
});